<h1 mat-mdc-dialog-title>Retirer l'article {{ data.article.designation }} du porteur {{ data.porteur.porteur }}</h1>
<div mat-dialog-content>
  <p>Etes-vous certain de vouloir retirer l'article  {{ data.article.designation }} à l'utilisateur {{ data.porteur.porteur }} ?</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="refuse()" color="white">Annuler</button>
  <button mat-raised-button (click)="valid()" cdkFocusInitial class="color">Confirmer</button>
</div>